import { type ReactElement } from "react"
import followerChatVertical from "~/images/landing/follower-chat-vertical.png"
import followerChatHorizontal from "~/images/landing/follower-chat-horizontal.png"
import { ResponsiveImage, BREAKPOINTS } from "../common/responsive-image"

function FollowerChatImageHorizontal(): ReactElement {
  return (
    <ResponsiveImage
      sources={[{ media: BREAKPOINTS.desktop, src: followerChatHorizontal }]}
      fallbackSrc={followerChatHorizontal}
      alt="Member chat"
      className="hidden md:block"
    />
  )
}

function FollowerChatImageVertical(): ReactElement {
  return (
    <ResponsiveImage
      sources={[
        { media: BREAKPOINTS.mobile, src: followerChatVertical },
        { media: BREAKPOINTS.tablet, src: followerChatVertical },
      ]}
      fallbackSrc={followerChatVertical}
      alt="Member chat"
      className="block md:hidden"
    />
  )
}

export function FollowerChatImage() {
  return (
    <>
      <FollowerChatImageHorizontal />
      <FollowerChatImageVertical />
    </>
  )
}
